import { deleteOne, fetchStream, get, post, put } from "@/modules/request";
import { Response, WriteResponse } from "@/types/api-types";

export const ApiPostStoryGameDialogCreateMany = (itemzz: StoryScene[]) =>
  post(`/StoryGameDialog/CreateMany`, { itemzz });

// 创建game
export const ApiPostStoryGame = (params: { name: string; mateId: number }) =>
  post("/StoryGame", params);

// 克隆game
export const ApiPostCloneStoryGame = (id: number) =>
  post("/StoryGameClone/" + id);

// 更新game
export const ApiPutStoryGame = (id: number, params: StoryGame) =>
  put("/StoryGame/" + id, params);

// 删除game
export const ApiDeleteStoryGame = (id: number) => deleteOne("/StoryGame/" + id);

// 发布game
export const ApiPostStoryGamePublish = (
  id: number,
  version: string,
  description: string
) => post("/StoryGamePublish/" + id, { version, description });

// 获取game
export const ApiGetStoryGame = (uuid: string) => get("/StoryGame/" + uuid);

export const ApiGetStoryGamePage = (
  {
    tab,
    type,
    mateId,
    reviewStatus,
  }: {
    tab?: "hot" | "recommend";
    type?: number;
    mateId?: number;
    reviewStatus?: number; // 1.待审核 2.审核通过 3.审核不通过
  } = {},
  { page = 1, perPage = 999 } = {},
  { field = "dtUpdate", order = "desc" } = {}
) => {
  const params =
    tab === "hot"
      ? {
          tab,
          pagination: { page, perPage },
        }
      : {
          filter: { mateId, type, reviewStatus },
          sort: { field, order },
          pagination: { page, perPage },
        };
  return get("/StoryGamePage", params);
};
export const ApiGetMateStoryGamePage = (mateId: number, status?: 1 | 2) =>
  get("/MateStoryGamePage", {
    filter: { mateId, status },
    sort: { field: "dtUpdate", order: "desc" },
    pagination: {
      page: 1,
      perPage: 999,
    },
  });

// game character
// 重新生成所有音色
export const ApiPostStoryGameCharacterDialogToneRegenerate = (id: number) =>
  post(`/StoryGameCharacterDialogToneRegenerate/${id}`);

// gameNode
// type: 1.开始节点 2.剧情点 3.结束节点
export const ApiPostStoryGameStoryNode = (storyGameId: number, type: number) =>
  post("/StoryGameStoryNode", { storyGameId, type });

// 更新gameNode
export const ApiPutStoryGameStoryNode = (id: number, params: StoryGameNode) =>
  put("/StoryGameStoryNode/" + id, params);

// 删除gameNode
export const ApiDeleteStoryGameStoryNode = (id: number) =>
  deleteOne("/StoryGameStoryNode/" + id);

// 获取gameNode
export const ApiGetStoryGameStoryNode = (storyGameId: number) =>
  get("/StoryGameStoryNode", { storyGameId });

// storyNode 克隆
export const ApiPostStoryGameStoryNodeClone = (storyNodeId: number) =>
  post("/StoryGameStoryNodeClone/" + storyNodeId);

// gameNode排序
export const ApiPostStoryGameStoryNodeSort = (params: {
  storyGameId: number;
  storyNodeIdzz: number[];
}) => post("/StoryGameStoryNodeSort", params);

// galGameDialog
// 创建
export const ApiPostStoryGameDialog = (
  params: Pick<
    StoryGameDialog,
    "storyNodeId" | "characterId" | "text" | "sceneMediaId" | "mateToneId"
  >
) => post("/StoryGameDialog", params);

// 更新
export const ApiPutStoryGameDialog = (
  id: number,
  params: Partial<
    Pick<
      StoryGameDialog,
      | "characterId"
      | "text"
      | "sceneMediaId"
      | "sceneMediaInfo"
      | "audioMediaId"
      | "nextDialogId"
    >
  >
) => put("/StoryGameDialog/" + id, params);

// 删除
export const ApiDeleteStoryGameDialog = (id: number) =>
  deleteOne("/StoryGameDialog/" + id);

// 排序
export const ApiPutStoryGameDialogSort = (params: {
  storyNodeId: number;
  dialogIdzz: number[];
}) => post("/StoryGameDialogSort", params);

// 获取
export const ApiGetStoryGameDialog = (storyNodeId: number) =>
  get("/StoryGameDialog", { storyNodeId });

// 获取item
export const ApiGetStoryGameDialogItem = (
  dialogId: number
): Promise<WriteResponse<StoryGameDialog>> =>
  get(`/StoryGameDialog/${dialogId}`);

// 获取dialog page根据 characterid
export const ApiGetStoryGameDialogPageByCharacterId = (
  {
    storyGameId,
    storyNodeId,
    characterId,
  }: { storyGameId: number; storyNodeId?: number; characterId?: number },
  { page = 1, perPage = 999 } = {}
) =>
  get("/StoryGameDialogPage", {
    filter: { storyGameId, storyNodeId, characterId },
    pagination: { page, perPage },
    sort: { field: "id", order: "asc" },
  });

//  根据 dialogId 重新生成音色
export const ApiPostStoryGameDialogToneRegenerate = (dialogId: number) =>
  post(`/StoryGameDialogToneRegenerate/${dialogId}`);

// dialog option
// 创建
export const ApiPostStoryGameDialogOption = (
  params: Pick<StoryGameDialogOption, "dialogId" | "text">
) => post("/StoryGameDialogOption", params);

// 更新
export const ApiPutStoryGameDialogOption = (
  id: number,
  params: Pick<StoryGameDialogOption, "nextDialogId" | "text" | "score">
) => put("/StoryGameDialogOption/" + id, params);

// 删除
export const ApiDeleteStoryGameDialogOption = (id: number) =>
  deleteOne("/StoryGameDialogOption/" + id);

// 获取
export const ApiGetStoryGameDialogOption = (dialogId: number) =>
  get("/StoryGameDialogOption", { dialogId });

// 构建StoryGame
export const ApiBuildStoryGame = (id: number) => post(`/StoryGameBuild/${id}`);

// 自动生成
// galgame 自动补全
export const ApiPostStoryGameComplete = (
  params: {
    type: number; // 1恋爱游戏
    name: string;
    description: string;
    character: {
      mateId: number;
      introduction: string;
    };
    player: {
      name: string;
      introduction: string;
    };
  },
  callback: <T>(content: Response<T> | string) => void | Promise<void>
) => fetchStream("/StoryGameComplete", "POST", params, callback);

// storyNode 自动补全
export const ApiPostStoryGameStoryNodeComplete = (
  params: {
    storyGameId: number;
    title: string;
    description: string;
  },
  callback: <T>(content: Response<T> | string) => void | Promise<void>
) => fetchStream("/StoryGameStoryNodeComplete", "POST", params, callback);

// storyNode 自动生成
export const ApiPostStoryGameStoryNodeGenerate = (storyGameId: number) =>
  post("/StoryGameStoryNodeGenerate", { storyGameId });

// dialog 自动生成
export const ApiPostStoryGameDialogGenerate = (storyNodeId: number) =>
  post("/StoryGameDialogGenerate", { storyNodeId });

export const ApiPostStoryGameDialogPortrait = (params: {
  dialogId: number;
  mediaId: number;
  mediaInfo: MediaTransform;
}) => post(`/StoryGameDialogPortrait`, params);

export const ApiDeleteStoryGameDialogPortrait = (id: number) =>
  deleteOne(`/StoryGameDialogPortrait/${id}`);

export const ApiPutStoryGameDialogPortrait = (
  id: number,
  params: {
    mediaId: number;
    mediaInfo: MediaTransform;
  }
) => put(`/StoryGameDialogPortrait/${id}`, params);

export const ApiPostStoryGameDialogAnimation = (params: {
  dialogId: number;
  animationId: number;
  mediaInfo: MediaTransform;
}) => post(`/StoryGameDialogAnimation`, params);

export const ApiDeleteStoryGameDialogAnimation = (id: number) =>
  deleteOne(`/StoryGameDialogAnimation/${id}`);

export const ApiPutStoryGameDialogAnimation = (
  id: number,
  params: {
    animationId: number;
    mediaInfo: MediaTransform;
  }
) => put(`/StoryGameDialogAnimation/${id}`, params);

// game media

// 创建
// type: 1.图片 2.视频
export const ApiPostStoryGameMedia = (params: {
  storyGameId: number;
  mediaId: number;
  type: number;
}) => post(`/StoryGameMedia`, params);

// 删除
export const ApiDeleteStoryGameMedia = (id: number) =>
  deleteOne(`/StoryGameMedia/${id}`);

// 更新
export const ApiPutStoryGameMedia = (
  id: number,
  params: {
    mediaId: number;
    type: number;
  }
) => put(`/StoryGameMedia/${id}`, params);

// 排序
export const ApiPutStoryGameMediaSort = (params: {
  storyGameId: number;
  mediaIdzz: number[];
}) => post(`/StoryGameMediaSort`, params);
